export interface DisplayLink {
  label: string;
  path: string;
  exact?: boolean;
  requiresAuth?: boolean;
  requiresUnauth?: boolean;
  requiresAdmin?: boolean;
}

export const displayedLinks: DisplayLink[] = [
  { label: 'Home', path: '/', exact: true },
  { label: 'Queue Stats', path: '/queue-stats' },
  { label: 'About', path: '/about' },
  { label: 'API', path: '/api-info' },
  { label: 'Contact', path: '/contact' }
];
